import React from "react";
import styled from "styled-components";

const StyledNav404 = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Nav404 = () => {
  return <StyledNav404>未找到您访问的页面，请检查地址是否有误</StyledNav404>;
};

export default Nav404;
